import React, { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { OfferingDetailsMultiPass } from "../template_offering_details_multipass";
import { useCoalitionSpaceAnalytics } from "./coalition-space_analytics";
import {
  generalInfo,
  partnerConfig,
  testimonials,
} from "./coalition-space_partner_config";

const Theme = lazyWithRetry(() => import("./coalition-space_theme"));

const faqs = [
  {
    question: "What are your hours?",
    answer:
      "Multi pass users will have access to the buildings during business hours Monday through Friday 9AM to 5PM.",
  },
  {
    question: "Is there easy access to public transportation?",
    answer:
      "Yes, all of our Coalition Space locations are conveniently located near major transportation hubs, so wherever you live getting to and from the office won't be an issue.",
  },
  {
    question: "How fast is your Internet speed?",
    answer:
      "We provide premium high-speed fiber internet in all of our Coalition Space locations. We also offer the option to opt for a premium port to members who are always working online.",
  },
  {
    question: "Can I cancel my multi-pass order?",
    answer:
      "We do not allow order cancellation for multi pass. However, you can cancel any multi pass booking you made and use it for another day.",
  },
  {
    question: "When does my multi-pass order expire?",
    answer: "Your multi pass will expire in 30 days upon purchase.",
  },
];

export function OfferingCoalitionSpaceMultiPass() {
  useCoalitionSpaceAnalytics();

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsMultiPass
        showAddress={false}
        showDirections
        partnerConfig={partnerConfig}
        data={{
          description: `Want to enjoy our space several times a week? Spend 5, 10, or 15 days at Coalition Space for a discounted rate with the multi pass!`,
          testimonials: testimonials,
          faqs: faqs,
          generalInfo,
        }}
      />
    </Fragment>
  );
}
